import { UserRole } from '@common/enums';
import React, { FC, useMemo } from 'react';

import { FormikSelectField } from '~/@components/FormikFields';
import { LocalizableText } from '~/@components/LocalizableText';
import { useProjectTimeSpentFormikContext } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/ProjectTimeSpentEditForm/ProjectTimeSpentFormik';
import { TimeSpentUser } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/types';
import { getUserFullName } from '~/utils/user';

export const ProjectTimeSpentUserSelect: FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    const formik = useProjectTimeSpentFormikContext();

    // Allow change only to the IN_PROGRESS dump load
    const items: TimeSpentUser[] = useMemo(
        () =>
            (formik.values.project.users || []).filter(u =>
                [UserRole.EXCAVATOR_OPERATOR, UserRole.DRIVER].includes(u.role)
            ),
        [formik]
    );

    const onChangeValue = (value: TimeSpentUser) => {
        if (formik.values.user !== value) {
            formik.setFieldValue('licensePlate', '');
            formik.setFieldTouched('licensePlate', true);
        }
    };

    return (
        <FormikSelectField
            label={<LocalizableText code={'ProjectDocuments.timeSpent.user'} />}
            name={'user'}
            formik={formik}
            items={items}
            renderValue={(user: TimeSpentUser) => getUserFullName(user)}
            keyGetter={(user: TimeSpentUser) => user.id}
            disabled={disabled}
            addEmptyOption={false}
            afterChange={onChangeValue}
        />
    );
};
